import styled from "styled-components";

import { BaseCell, CombinedIcon, TooltipTextAnchorCell } from "@similarweb/pro-logic-components";
import { truncateText } from "@similarweb/styles";

export const AppCellWrapper = styled(BaseCell)`
    display: flex;
    align-items: center;
    gap: 8px;
    padding-right: 12px;
`;

export const BadgeWrapper = styled.div`
    position: absolute;
    bottom: -2px;
    right: -4px;
    width: 12px;
    height: 12px;
`;

export const StyledCombinedIcon = styled(CombinedIcon)`
    flex-shrink: 0;
`;

export const StyledTextAnchorCell = styled(TooltipTextAnchorCell)`
    ${truncateText()};

    min-width: 0;
`;
